import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FirebaseUtilitiesService } from 'src/app/services/firebase-utilities.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-active-consultant',
    templateUrl: './active-consultant.component.html',
    styleUrls: ['./active-consultant.component.scss'],
    standalone: false
})
export class ActiveConsultantComponent implements OnChanges {
  @Input() consultant: any;
  @Input() consultants: any;
  @Input() patientDocId: string;
  @Input() caseName: string;
  @Input() selectedFiles: any = [];
  @Input() sharedFilesCount: number = 0;
  @Input() selected: boolean;
  @Input() restrictedProfiles: any = [];
  @Input() allFiles: any[] = []; // Add input for all files
  @Output() needConsultantsReloadEvent: EventEmitter<any> = new EventEmitter();
  @Output() goToFolderEvent: EventEmitter<any> = new EventEmitter();
  @Output() shareEvent: EventEmitter<any> = new EventEmitter();
  @Output() unshareEvent: EventEmitter<any> = new EventEmitter();

  // Add properties for consultant folder functionality
  isExpanded: boolean = false;
  sharedFiles: any[] = [];
  loadingSharedFiles: boolean = false;

  constructor(
    public snackBar: MatSnackBar,
    private firebase_utilities_$: FirebaseUtilitiesService,
    private Utils$: UtilsService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    // Refresh shared files when allFiles changes
    if (changes['allFiles'] && this.isExpanded) {
      this.loadSharedFiles();
    }
  }

  isRestrictedProfile(consultant): boolean {
    if (!this.restrictedProfiles) return false;
    if (this.restrictedProfiles.length === 0) return false;
    return this.restrictedProfiles.includes(consultant.uid);
  }

  share(consultant) {
    this.shareEvent.emit({ email: consultant.email, uid: consultant.uid });
  }

  goToIndex(event) {
    event.stopPropagation();
    event.preventDefault();
    this.goToFolderEvent.emit({ folderId: 'all', consultant: this.consultants._value[0] });
  }

  unShare(consultant) {
    this.unshareEvent.emit({ consultant: consultant.email, type: 'single' });
  }

  checkSelectedShared(consultant, selectedFiles) {
    if (selectedFiles.length < 2) return false;
    return selectedFiles.every(file => this.fileIsShared(consultant, file));
  }

  fileIsShared(consultant, file) {
    return this.Utils$.fileIsShared(consultant, file);
  }

  makeProfilePublic(event, consultant) {
    event.stopPropagation();
    event.preventDefault();
    this.firebase_utilities_$
      .makeProfilePublic(this.patientDocId, consultant.uid)
      .then(r => this.afterProfileUpdated())
      .catch(e => console.log(e));
  }

  private afterProfileUpdated() {
    this.snackBar.open('Profile visibility updated', 'OK', { duration: 2000 });
    this.needConsultantsReloadEvent.emit();
  }

  checkSelected(consultant) {
    if (this.selectedFiles.length > 1) return this.checkSelectedShared(consultant, this.selectedFiles) ? true : false;
  }

  makeProfileRestricted(event, consultant) {
    event.stopPropagation();
    event.preventDefault();
    this.firebase_utilities_$
      .makeProfileRestricted(this.patientDocId, consultant.uid)
      .then(r => this.afterProfileUpdated())
      .catch(e => console.log(e));
  }

  // Add new methods for consultant folder functionality
  toggleExpanded(event) {
    event.stopPropagation();
    event.preventDefault();
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded && this.sharedFiles.length === 0) {
      this.loadSharedFiles();
    }
  }

  private loadSharedFiles() {
    if (!this.allFiles || this.allFiles.length === 0) {
      this.sharedFiles = [];
      return;
    }

    this.loadingSharedFiles = true;

    // Filter files that are shared with this consultant
    this.sharedFiles = this.allFiles.filter(file => {
      return (
        file.sharedUsers &&
        file.sharedUsers.length > 0 &&
        file.sharedUsers.some(user => user.email === this.consultant.email)
      );
    });

    this.loadingSharedFiles = false;
  }

  getSharedFilesCount(): number {
    return this.sharedFiles.length;
  }

  hasSharedFiles(): boolean {
    return this.sharedFiles.length > 0;
  }

  // Method to refresh shared files (can be called externally)
  refreshSharedFiles() {
    if (this.isExpanded) {
      this.loadSharedFiles();
    }
  }
}
